// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6171 ? "11f72889" : chunkId) + "." + {"6171":"fda9fb29e1981920","8311":"2fb1cfa6460992f6"}[chunkId] + ".js";
};